import React from "react";

import { LinkInterface } from "@/components/Links/types";
import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContext } from "@/contexts/QREditorContext";

import { applyQRFormDefaultValues, onBindClick } from "@/utils/formHelper";
import {
  omittedValues,
  onBindImage,
  onBindSocialNetworks,
  onBindThemePicker,
} from "@/utils/qrEditorHelper";

import { qrLinksValidation } from "@/utils/validators/qr-listoflinks";

import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QRLinksProps } from "./types";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export const QRLinks = ({ data }: QRLinksProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"links">>(QREditorContext);

  const [qrLinkData, setQrLinkData] = React.useState<QRProps<"links">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const dataLinksWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  const onUpdateState = ({ field, value }) => {
    if (field === "file" || field == "") return;
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          [field]: value,
        },
      },
      [...omittedValues(qrData.data)]
    );
  };

  onBindImage(dataLinksWithDefaultValues, "qrLinksInformationLogo", [
    ...omittedValues(qrData.data),
  ]);
  onBindThemePicker(dataLinksWithDefaultValues, "qrLinksThemePicker", [
    ...omittedValues(qrData.data),
  ]);
  onBindSocialNetworks(
    dataLinksWithDefaultValues,
    "qrLinksSocials",
    "socialNetworks",
    [...omittedValues(qrData.data)],
    true,
    qrLinkData
  );

  onBindClick(dataLinksWithDefaultValues, "qrLinksList", (addedLinks: LinkInterface[]) => {
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          links: addedLinks,
        },
      },
      [...omittedValues(qrData.data)]
    );
    setQrLinkData({
      ...qrData,
      data: {
        ...qrData.data,
        links: addedLinks,
      },
    });
  });

  React.useEffect(() => {
    setQrLinkData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrLinkData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-links">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataLinksWithDefaultValues}
        schema={qrLinksValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => {
          setRenderForm(isValidForm);
        }}
      />
    </div>
  );
};
